
import Box from '@mui/material/Box'
import ShrimpTransferRecordCard from '../ShrimpTransferRecordCard'
import ShrimpTransfersRecordBody from '../ShrimpTransferRecordBody'

const ShrimpTransferRecord = () => {

  return (
    <Box>
      <ShrimpTransferRecordCard>
        <ShrimpTransfersRecordBody />
      </ShrimpTransferRecordCard>
    </Box>
  )
}

export default ShrimpTransferRecord
